(function ($) {
	var assocPlano = "Número Mágico - Atendimento 24 Horas";
	var url = String(window.location);
	planoSelecionado = url.split("?");
	if (planoSelecionado[1]) {
		assocPlano = planoSelecionado[1];
	}


	$(document).ready(function () {

		$('#aparecer').removeClass('elementor-invisible');

		$('#numero0800').removeClass('elementor-invisible');


	});

	$(window).ready(function () {
		$('.eael-fancy-text-strings').css('display', 'block');
	})

	function capitalizeFirstLetter(string) {
		return string.replace(/\w\S*/g, function (txt) { return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase(); });
	}
	//Associar
	switch (assocPlano) {
		case 'numeroMagico':
			tag_plano = 'At10h';
			plano = 'Número Mágico 10h';
			break;
		case 'nm24horas':
			tag_plano = 'At24h';
			plano = 'Número Mágico 24h';
			break;
		case 'Plano Virtus Remoto':
			tag_plano = 'VRemoto';
			plano = 'Sistema Virtus Remoto';
			break;
		case '0800':
			plano = '0800 + Atendimento 24h (Numero Mágico)';
			break;
		case 'actus':
			plano = 'Actus 24h';
			break;
		default:
			plano = "Número Mágico - Atendimento 24 Horas";
			break;
	}
	$('#assocPlano > option').val(plano).text(plano);
	$('#assocBtn').click(function () {
		var nome = $('#assocNome').val();
		var email = $('#assocEmail').val();
		var tel = $('#assocTel').val();
		var cel = $('#assocCel').val();
		var tag_plano;
		var plano;
		switch (capitalizeFirstLetter(assocPlano)) {
			case 'Número Mágico 10h':
				tag_plano = 'At10h';
				plano = 'Número Mágico 10h';
				break;
			case 'Plano Número Mágico 24h':
				tag_plano = 'At24h';
				plano = 'Número Mágico 24h';
				break;
			case 'Plano Virtus Remoto':
				tag_plano = 'VRemoto';
				plano = 'Sistema Virtus Remoto';
				break;
			case 'Plano 0800':
				tag_plano = '0800';
				plano = '0800 + Atendimento 24h (Numero Mágico)';
				break;
			case 'Actus 24h':
				tag_plano = 'Actus';
				plano = 'Actus';
				break;
			default:
				tag_plano = '';
				plano = '';
				break;
		}
		$.ajax({
			type: "POST",
			data: {
				'nome': nome,
				'email': email,
				'tel': tel,
				'cel': cel,
				'plano': plano,
				'tags': tag_plano
			},
			dataType: "JSON",
			url: "https://callbacks.prestus.com.br/siteapi/v1/associar", //Variavel criada na criação do JS no functions
			success: function (retorno) {
				if (retorno.status == 1) {
					let opts = {
						title: 'Erro!',
						text: retorno.msg
					};
					PNotify.alert(opts);

				} else {

					let opts = {
						title: 'Sucesso',
						text: retorno.msg
					};
					PNotify.alert(opts);
					$('.wpcf7-form').hide();
					$('#btnOutAssoc').hide();
					$('#assocMsg').show();
				}
			}
		});

	})

	//proposta 1 min
	$('#proposta').click(function (event) {
		event.preventDefault();
		window.uetq = window.uetq || [];
		window.uetq.push("event", "fezProposta", {});
		
		if (!($('#priv').is(':checked'))) {
			let opts = {
				title: 'Atenção!',
				text: 'É preciso aceitar nossas políticas de privacidade para prosseguir com a prosposta!'
			};
			PNotify.alert(opts);
			return false;
		}

		var quanto = $('#quantAtendimentos option:selected').val();
		var segmento = $('#segmento option:selected').val();
		var nome = $('#nome').val();
		var empresa = $('#empresa-props').val();
		var celular = $('#celular').val();
		var email = $('#email1min').val();
		var c_umtz = read_cookie("__utmz");
		var traffic_source = read_cookie("__trf.src");
		var client_id = read_cookie("rdtrk") ? JSON.parse(decodeURIComponent(read_cookie("rdtrk"))).id : false;

		$.ajax({
			type: "POST",
			data: {
				'quanto': quanto,
				'segmento': segmento,
				'nome': nome,
				'empresa': empresa,
				'celular': celular,
				'email': email,
				'c_umtz': c_umtz,
				'traffic_source': traffic_source,
				'client_id': client_id
			}, //nome da função desejada nos functions
			dataType: "JSON",
			url: "https://callbacks.prestus.com.br/siteapi/v1/orcamentords", //Variavel criada na criação do JS no functions
			success: function (retorno) {
				if (retorno.status == 1) {
					let opts = {
						title: 'Erro!',
						text: retorno.msg
					};
					PNotify.alert(opts);
				} else {
					let opts = {
						title: 'Sucesso',
						text: retorno.msg
					};
					PNotify.alert(opts);
					window.open("http://promo.prestus.com.br/obrigado-proposta1minuto");
				}
			}
		});
	});

	//Degustação
	$('#degBtn').click(function () {
		var nome = $('#degNome').val();
		var email = $('#degEmail').val();
		var cel = $('#degCelular').val();
		var empresa = $('#degEmpresa').val();

		$.ajax({
			type: "POST",
			data: {
				'nome': nome,
				'telefone': cel,
				'email': email,
				'empresa': empresa
			},
			dataType: "JSON",
			url: "https://callbacks.prestus.com.br/siteapi/v1/degustacao", //Variavel criada na criação do JS no functions
			success: function (retorno) {
				if (retorno.status == 1) {
					let opts = {
						title: 'Erro!',
						text: retorno.msg
					};
					PNotify.alert(opts);
				} else {
					$('#antes').hide();
					$('#depois').show();
					$('#numero').text(retorno.data.numero);
					$('#numero').css('font-size', '70pt').css('font-weight', 'bold').css('color', '#175fb7');
					$('#empresa').text(retorno.data.empresa);
					let opts = {
						title: 'Sucesso',
						text: retorno.data.numero
					};
					PNotify.alert(opts);
				}
			}
		});
	});

	//experimente
	$('#expBtn').click(function () {
		if (!($('#priv-exp').is(':checked'))) {
			let opts = {
				title: 'Atenção!',
				text: 'É preciso aceitar nossas políticas de privacidade para prosseguir com a prosposta!'
			};
			PNotify.alert(opts);
			return false;
		}

		var nome = $('#expNome').val();
		var email = $('#expEmail').val();
		var celular = $('#expCelular').val();
		var empresa = $('#expEmpresa').val();
		var segmento = $('#expSegmento').val();
		var c_umtz = read_cookie("__utmz");
		var traffic_source = read_cookie("__trf.src");
		var client_id = read_cookie("rdtrk") ? JSON.parse(decodeURIComponent(read_cookie("rdtrk"))).id : false;

		$.ajax({
			type: "POST",
			data: {
				'nome': nome,
				'celular': celular,
				'email': email,
				'segmento': segmento,
				'empresa': empresa,
				'c_umtz': c_umtz,
				'traffic_source': traffic_source,
				'client_id': client_id
			},
			dataType: "JSON",
			url: "https://callbacks.prestus.com.br/siteapi/v1/experimente", //Variavel criada na criação do JS no functions
			success: function (retorno) {
				if (retorno.status == 1) {
					let opts = {
						title: 'Erro!',
						text: retorno.msg
					};
					PNotify.alert(opts);
				} else {
					$('#antes').hide();
					$('#depois').show();
					$('#numero').text(retorno.data.numero);
					$('#empresa').text(retorno.data.empresa);
					let opts = {
						title: 'Sucesso',
						text: retorno.msg
					};
					PNotify.alert(opts);
					$('#expBtn').prop("disabled", true);
				}
			}
		});
	});

	//contato
	$('#contBtn').click(function (e) {
		if (!($('#priv-cont').is(':checked'))) {
			let opts = {
				title: 'Atenção!',
				text: 'É preciso aceitar nossas políticas de privacidade para prosseguir com a prosposta!'
			};
			PNotify.alert(opts);
			return false;
		}

		var nome = $('#contNome').val();
		var empresa = $('#contEmp').val();
		var email = $('#contEmail').val();
		var mensagem = $('#contMen').val();
		var cel = $('#contCel').val();
		var c_utmz = read_cookie("__utmz");
		var traffic_source = read_cookie("__trf.src");
		var client_id = read_cookie("rdtrk") ? JSON.parse(decodeURIComponent(read_cookie("rdtrk"))).id : false;
		$.ajax({
			type: "POST",
			data: {
				'nome': nome,
				'telefone': cel,
				'empresa': empresa,
				'email': email,
				'mensagem': mensagem,
				'c_utmz': c_utmz,
				'traffic_source': traffic_source,
				'client_id': client_id
			},
			dataType: "JSON",
			url: "https://callbacks.prestus.com.br/siteapi/v1/contato", //Variavel criada na criação do JS no functions
			success: function (retorno) {
				if (retorno.status == 1) {
					let opts = {
						title: 'Erro!',
						text: retorno.msg,
						addclass: 'stack-bottomright'
					};
					PNotify.alert(opts);
					e.preventDefault();
				} else {
					let opts = {
						title: 'Sucesso',
						text: retorno.msg
					};
					PNotify.alert(opts);
					$(".wpcf7-form").submit();
				}
			}
		});
	});

	//vaga
	$('#vagaBtn').click(function () {
		var nome = $('#vagaNome').val();
		var email = $('#vagaEmail').val();
		var cel = $('#vagaCel').val();
		console.log(nome + ', ' + email + ', ' + cel);
		$.ajax({
			type: "POST",
			data: {
				'nome': nome,
				'telefone': cel,
				'email': email
			},
			dataType: "JSON",
			url: "https://callbacks.prestus.com.br/siteapi/v1/vagas", //Variavel criada na criação do JS no functions
			success: function (retorno) {
				if (retorno.status == 1) {
					let opts = {
						title: 'Erro!',
						text: retorno.msg
					};
					PNotify.alert(opts);
				} else {
					let opts = {
						title: 'Sucesso',
						text: retorno.msg
					};
					PNotify.alert(opts);
				}
			}
		});

	});

	//aparecer telefone
	$('#lnk_ShowNumber').click(function () {
		$(this).text('0800 607 1538');
		window.uetq = window.uetq || [];
		window.uetq.push("event", "showNumber", {});
	});

	//newsLetter
	$('#newsBtn').click(function (event) {
		event.preventDefault();

		if (!($('#priv-news').is(':checked'))) {
			let opts = {
				title: 'Atenção!',
				text: 'É preciso aceitar nossas políticas de privacidade para prosseguir com a prosposta!'
			};
			PNotify.alert(opts);
			return false;
		}

		var nome = $('#newsNome').val();
		var email = $('#newsEmail').val();
		var c_umtz = read_cookie("__utmz");
		var traffic_source = read_cookie("__trf.src");
		var client_id = read_cookie("rdtrk") ? JSON.parse(decodeURIComponent(read_cookie("rdtrk"))).id : false;
		//var client_id = read_cookie("rdtrk") ? JSON.parse(decodeURIComponent(read_cookie("rdtrk"))).id : false;
		$.ajax({
			type: "POST",
			data: {
				action: 'newsDev', 'nome': nome, 'email': email, 'c_umtz': c_umtz,
				'traffic_source': traffic_source,
				'client_id': client_id
			}, //nome da função desejada nos functions
			dataType: "JSON",
			url: "https://callbacks.prestus.com.br/siteapi/v1/newsdev", //Variavel criada na criação do JS no functions
			success: function (retorno) {
				if (retorno.status == 0) {
					let opts = {
						title: 'Erro!',
						text: retorno.msg
					};
					PNotify.alert(opts);
				} else {
					$('#news').hide();
					$('#newsBtn').hide();

					let opts = {
						title: 'Sucesso',
						text: retorno.msg
					};
					PNotify.alert(opts);
				}
			}
		});

	});

	/* 04.DEZ.2024 - Interceptando clique nos botões de falar com o Edvaldo
					 e simulando um clique no widget do RDStation. */
	$(".Botao_wpp").click(function (event) {
		event.preventDefault();
		$("button[id*='rd-floating_button']").trigger( "click" );
	});


	/*	Função de apoio para extração de informações de cookies
		Funciona em conjunto com o formulário de proposta1minuto
		para envio de informações relacionadas ao reconhecimento
		de origem do visitante.
	*/
	function read_cookie(a) {
		var b = a + "=";
		var c = document.cookie.split(";");
		for (var d = 0; d < c.length; d++) {
			var e = c[d];
			while (e.charAt(0) == " ") e = e.substring(1, e.length);
			if (e.indexOf(b) == 0) {
				return e.substring(b.length, e.length)
			}
		}
		return null
	}

})(jQuery);
